import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {  Router } from '@angular/router';
import { RouteConstant } from '../../../../core/_constants/route.constant';
 import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/_services/pages/auth.service';
import { LocalStorageProvider } from 'src/app/core/_services/common/storage.service';
import { CookieService } from 'ngx-cookie-service';
import { AppConst, APP_CONSTANT } from 'src/app/core/_constants/app.constant';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { PagesService } from 'src/app/core/_services/pages/pages.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessagingService } from 'src/app/core/_services/messaging.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public loginForm: FormGroup;
  submitted: boolean = false;
  rem: boolean = false;
  hide = true;
  validationErrorMessage = APP_CONSTANT.VALIDATION
  constructor(
    private router:Router,
    private fb: FormBuilder,
     private toastr: ToastrService,
     private authService: AuthService,
     private storageService: LocalStorageProvider,
     private cookieService: CookieService,
     private service: PagesService,
     private loader: NgxUiLoaderService,
     private messagingService:MessagingService
    ) { 
      this.loginForm = this.fb.group({
        email: ['', [Validators.required, Validators.email,Validators.pattern(AppConst.EMAIL_PATTERN)]],
        password: ['', Validators.required],
        remember: [false]
      })
    }

  ngOnInit(): void {
    this.loginForm.get('email')!.setValue(this.email);
    this.loginForm.get('password')!.setValue(this.password);
  
    if ( this.cookieService.get('rem')) {
      this.rem = true;
      this.loginForm.get('remember')!.setValue(true);
    }

  }
  get email(): any {
    if ( this.cookieService.get('rem')) {
      return  this.cookieService.get('email');
    } else {
      return '';
    }
  }

  get password(): any {
    if (this.cookieService.get('rem')) {
      var decPass = this.cookieService.get('password');
      var decodedPass = atob(decPass);
      return decodedPass;
    } else {
      return '';
    }
  }

  get f() { return this.loginForm.controls; }


  login(post:any){
    let token= this.messagingService.getToken();
    this.submitted = true;
    if (post.remember === true) {
      this.cookieService.set("rem", "true");
      this.cookieService.set("email", post.email);
      var encodedPass = btoa(post.password);
      this.cookieService.set("password", encodedPass);
    } else {
      this.cookieService.deleteAll();;
    }
    if (this.loginForm.valid) {
      this.loader.start();
      let credentials = { ...{ email: post.email.trim(), password: post.password.trim(),deviceToken:token||'sfdgfh'} }
      this.authService.login(credentials).pipe().subscribe(response => {
        this.loader.stop();
        if(response.status){
          const token =  response.data;
          this.storageService.setItem('token',token)
          this.getProfileDetails();
          this.toastr.success(response.msg);
        }else {
          this.toastr.error(response.msg)
        }
      }, (err:any) => {
        this.loader.stop();
        this.toastr.error(err?.error?.msg);
      }
      );
    }
  }

  getProfileDetails(){
    this.service.get({},`${API_ROUTES.ACCOUNT.viewProfile}`).pipe().subscribe(response => {
      this.loader.start();
      if(response.status){
        const adminProfile = response.data;
        this.storageService.setItem('CurrentUser',adminProfile);
        if(adminProfile?.valorPaytechObj){
          this.storageService.setItem('opAvail', true);
        } else {
          this.storageService.setItem('opAvail', false);
        }
        console.log(adminProfile)
        this.router.navigateByUrl(`/${RouteConstant.Dashboard}`);
      }
      this.loader.stop();
    })
  }

  forgotPassword(){
    this.router.navigate([`${RouteConstant.ForgotPassword}`])
  }

}
